import React from "react";

import ACIconWrapper, { ACIconProps } from "./ACIconWrapper";

export default function TableChartIcon(props: ACIconProps) {
  return <ACIconWrapper component={IconSvg} {...props} />;
}

const IconSvg = () => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      height="1em"
      viewBox="0 0 36 36"
      fill="none"
    >
      <path
        d="M12.5 9C13.3284 9 14 9.67157 14 10.5C14 11.3284 13.3284 12 12.5 12L5.5 12C4.67157 12 4 11.3284 4 10.5C4 9.67157 4.67157 9 5.5 9L12.5 9Z"
        fill="#927BF0"
      />
      <path
        d="M21.5 9C22.3284 9 23 9.67157 23 10.5C23 11.3284 22.3284 12 21.5 12L17.5 12C16.6716 12 16 11.3284 16 10.5C16 9.67157 16.6716 9 17.5 9L21.5 9Z"
        fill="#927BF0"
      />
      <path
        d="M30.5 9C31.3284 9 32 9.67157 32 10.5C32 11.3284 31.3284 12 30.5 12L26.5 12C25.6716 12 25 11.3284 25 10.5C25 9.67157 25.6716 9 26.5 9L30.5 9Z"
        fill="#927BF0"
      />
      <path
        d="M12.5 14C13.3284 14 14 14.6716 14 15.5C14 16.3284 13.3284 17 12.5 17L5.5 17C4.67157 17 4 16.3284 4 15.5C4 14.6716 4.67157 14 5.5 14L12.5 14Z"
        fill="#CCBFFF"
      />
      <path
        d="M21.5 14C22.3284 14 23 14.6716 23 15.5C23 16.3284 22.3284 17 21.5 17L17.5 17C16.6716 17 16 16.3284 16 15.5C16 14.6716 16.6716 14 17.5 14L21.5 14Z"
        fill="#CCBFFF"
      />
      <path
        d="M30.5 14C31.3284 14 32 14.6716 32 15.5C32 16.3284 31.3284 17 30.5 17L26.5 17C25.6716 17 25 16.3284 25 15.5C25 14.6716 25.6716 14 26.5 14L30.5 14Z"
        fill="#CCBFFF"
      />
      <path
        d="M12.5 19C13.3284 19 14 19.6716 14 20.5C14 21.3284 13.3284 22 12.5 22L5.5 22C4.67157 22 4 21.3284 4 20.5C4 19.6716 4.67157 19 5.5 19L12.5 19Z"
        fill="#CCBFFF"
      />
      <path
        d="M21.5 19C22.3284 19 23 19.6716 23 20.5C23 21.3284 22.3284 22 21.5 22L17.5 22C16.6716 22 16 21.3284 16 20.5C16 19.6716 16.6716 19 17.5 19L21.5 19Z"
        fill="#CCBFFF"
      />
      <path
        d="M30.5 19C31.3284 19 32 19.6716 32 20.5C32 21.3284 31.3284 22 30.5 22L26.5 22C25.6716 22 25 21.3284 25 20.5C25 19.6716 25.6716 19 26.5 19L30.5 19Z"
        fill="#CCBFFF"
      />
      <path
        d="M12.5 24C13.3284 24 14 24.6716 14 25.5C14 26.3284 13.3284 27 12.5 27L5.5 27C4.67157 27 4 26.3284 4 25.5C4 24.6716 4.67157 24 5.5 24L12.5 24Z"
        fill="#CCBFFF"
      />
      <path
        d="M21.5 24C22.3284 24 23 24.6716 23 25.5C23 26.3284 22.3284 27 21.5 27L17.5 27C16.6716 27 16 26.3284 16 25.5C16 24.6716 16.6716 24 17.5 24L21.5 24Z"
        fill="#CCBFFF"
      />
      <path
        d="M30.5 24C31.3284 24 32 24.6716 32 25.5C32 26.3284 31.3284 27 30.5 27L26.5 27C25.6716 27 25 26.3284 25 25.5C25 24.6716 25.6716 24 26.5 24L30.5 24Z"
        fill="#CCBFFF"
      />
    </svg>
  );
};
